

import eService from "../services/eServiceDataService";

export default {
  name: 'Home',
  watch: {
    '$store.state.language': function() {
      this.lang = this.$store.state.language;
      this.showContent();
    }
  },
  async created() {

    await eService.getManulifePages().then(res => {
      this.menu =  res;
    })

    document.title = "Manulife Portal";

  },
  computed: {
    displayContent: function () {
      if( this.pageCookie === null ){
        if(this.lang === "en") {
          return this.message_en;
        } else {
          return this.message_zh;
        }
      } else {
        return this.pageCookie[0]["remarks_" + (this.$store.state.language)];
      }
    }
  },
  data () {
    return {
      lang : this.$store.state.language,
      content : "",
      pageCookie : JSON.parse(localStorage.getItem('pages')),
      message_en : "Eligibility of services is subject to the medical plan chosenInformation may vary from time to time. So, please call our Customer Hotline for the most updated information.Customer Hotline: (852) 8200-8223",
      message_zh : "可享有之服務範圍以閣下所選之醫療計劃為準。醫療網絡資料或會作出更改，煩請閣下致電本公司的客戶熱線查詢最新的醫療網絡醫生資料。客戶熱線：(852) 8200-8223",
      menu : []
    }
  },
  methods :{
    showContent: function () {
      if( this.pageCookie === null ){
        this.lang === "en" ? this.content = this.message_en : this.content = this.message_zh;
      } else {
        this.$store.state.language === "en" ? this.content = this.pageCookie[0]["remarks_en"] : this.content = this.pageCookie[0]["remarks_zh"]
      }
    },
    clickTips(){
      if(this.lang !== "en"){
        window.open(
            "https://www.qhms.com/health-info/health-videos",
            '_blank'
        );
      } else {
        window.open(
            "https://www.qhms.com/en/health-info/health-videos",
            '_blank'
        );
      }
    }
  }
}
